// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_66N","cls2":"SearchBox-cls2_kBu SearchBox-cls1_66N"};